import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMouseClassic2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="mouse-classic-2, click"><path d="M18.25 14.9999V2.74992L5.75 2.74976V14.9999C5.75 18.4517 8.54822 21.2499 12 21.2499C15.4518 21.2499 18.25 18.4517 18.25 14.9999Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 2.75V9.75" stroke="currentColor" strokeWidth="1.5"/><path d="M6 9.75H18" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMouseClassic2;
